﻿<template>
  <header class="header">
    <header_menu></header_menu>
  </header>

  <main class="main cart-page">
    <div class="cart-head" v-if="!isInternal_Booking_Engine()">
      <div>
        <h1>Your trip cart</h1>
        <p v-if="!cartEmpty()" class="cart-subtitle" v-html="header_text()"></p>
      </div>
      <button type="button" class="cart-continue" @click="$router.push('/')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
        Continue browsing
      </button>
      <!--<basket_header :position="1"></basket_header>-->
    </div>

    <div class="cart-layout">
      <div class="cart-main">
        <div v-if="cartEmpty()" class="cart-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" /></svg>
          <h3>Your cart is empty</h3>
          <p>Have a look at some of our trips below.</p>
        </div>
        <div v-else>
          <basket></basket>
        </div>
        <add_ons v-for="trip in get_Basket().trips" :key="trip.tour_id" :trip="trip"></add_ons>
        <tours v-if="!isInternal_Booking_Engine()"></tours>
      </div>

      <trip_summary></trip_summary>
    </div>
  </main>

  <footer_item v-if="!isInternal_Booking_Engine()"></footer_item>
</template>

<script lang="ts" src="./3_cart.ts"></script>
